import React, { useState, useEffect } from 'react';

function BillingPage() {

  useEffect(() => {
    console.log('Billing component rendered');
  }, []);

  const [billingInfo, setBillingInfo] = useState({
    plan: 'Pro',
    nextBillingDate: '2025-07-15',
    paymentMethod: {
      type: 'Credit Card',
      last4: '4242',
      expiry: '05/25'
    },
    billingAddress: {
      street: '123 Concordia Lane',
      city: 'Seward',
      state: 'NE',
      zip: '68434',
      country: 'USA'
    },
    invoices: [
      { id: 'INV-2025-06', date: '2023-06-15', amount: 29.99, status: 'Paid' },
      { id: 'INV-2025-05', date: '2023-05-15', amount: 29.99, status: 'Paid' },
      { id: 'INV-2025-04', date: '2023-04-15', amount: 29.99, status: 'Paid' }
    ]
  });

  const [isEditingPayment, setIsEditingPayment] = useState(false);
  const [isEditingAddress, setIsEditingAddress] = useState(false);
  const [paymentForm, setPaymentForm] = useState({
    cardNumber: '',
    cardName: '',
    expiry: '',
    cvv: ''
  });
  const [addressForm, setAddressForm] = useState({...billingInfo.billingAddress});

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPaymentForm({
      ...paymentForm,
      [name]: value
    });
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setAddressForm({
      ...addressForm,
      [name]: value
    });
  };
  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    // Simulate payment method update
    setBillingInfo({
      ...billingInfo,
      paymentMethod: {
        type: 'Credit Card',
        last4: paymentForm.cardNumber.slice(-4),
        expiry: paymentForm.expiry
      }
    });
    setIsEditingPayment(false);
  };

  const handleAddressSubmit = (e) => {
    e.preventDefault();
    setBillingInfo({
      ...billingInfo,
      billingAddress: addressForm
    });
    setIsEditingAddress(false);
  };
  return (
    <>
      <div className="account-header">
        <h2>Billing & Subscription</h2>
      </div>

      <div className="billing-section">
        <h3>Current Plan</h3>
        <div className="plan-details">
          <div className="detail-group">
            <span className="detail-label">Plan:</span>
            <span className="detail-value">{billingInfo.plan}</span>
          </div>
          <div className="detail-group">
            <span className="detail-label">Next billing date:</span>
            <span className="detail-value">{billingInfo.nextBillingDate}</span>
          </div>
          <div className="plan-actions">
            <button className="secondary-button">Upgrade Plan</button>
            <button className="danger-button">Cancel Subscription</button>
          </div>
        </div>
      </div>

      <div className="billing-section">
        <div className="section-header">
          <h3>Payment Method</h3>
          {!isEditingPayment && (
            <button
              className="edit-button"
              onClick={() => setIsEditingPayment(true)}
            >
              Update
            </button>
          )}
        </div>

        {isEditingPayment ? (
          <form onSubmit={handlePaymentSubmit} className="account-form">
            <div className="form-group">
              <label htmlFor="cardName">Name on Card</label>
              <input
                type="text"
                id="cardName"
                name="cardName"
                value={paymentForm.cardName}
                onChange={handlePaymentChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="cardNumber">Card Number</label>
              <input
                type="text"
                id="cardNumber"
                name="cardNumber"
                value={paymentForm.cardNumber}
                onChange={handlePaymentChange}
                placeholder="•••• •••• •••• ••••"
                required
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="expiry">Expiration Date</label>
                <input
                  type="text"
                  id="expiry"
                  name="expiry"
                  value={paymentForm.expiry}
                  onChange={handlePaymentChange}
                  placeholder="MM/YY"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="cvv">CVV</label>
                <input
                  type="text"
                  id="cvv"
                  name="cvv"
                  value={paymentForm.cvv}
                  onChange={handlePaymentChange}
                  placeholder="123"
                  required
                />
              </div>
            </div>

            <div className="button-group">
              <button type="submit" className="save-button">Save Payment Method</button>
              <button
                type="button"
                className="cancel-button"
                onClick={() => setIsEditingPayment(false)}
              >
                Cancel
              </button>
            </div>
          </form>
        ) : (
          <div className="payment-info">
            <div className="card-info">
              <div className="card-type">{billingInfo.paymentMethod.type}</div>
              <div className="card-details">
                <span>•••• •••• •••• {billingInfo.paymentMethod.last4}</span>
                <span>Expires {billingInfo.paymentMethod.expiry}</span>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="billing-section">
        <div className="section-header">
          <h3>Billing Address</h3>
          {!isEditingAddress && (
            <button
              className="edit-button"
              onClick={() => setIsEditingAddress(true)}
            >
              Update
            </button>
          )}
        </div>

        {isEditingAddress ? (
          <form onSubmit={handleAddressSubmit} className="account-form">
            <div className="form-group">
              <label htmlFor="street">Street Address</label>
              <input
                type="text"
                id="street"
                name="street"
                value={addressForm.street}
                onChange={handleAddressChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="city">City</label>
              <input
                type="text"
                id="city"
                name="city"
                value={addressForm.city}
                onChange={handleAddressChange}
                required
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="state">State</label>
                <input
                  type="text"
                  id="state"
                  name="state"
                  value={addressForm.state}
                  onChange={handleAddressChange}
                  required
                />
	      </div>
              <div className="form-group">
                <label htmlFor="zip">ZIP Code</label>
                <input
                  type="text"
                  id="zip"
                  name="zip"
                  value={addressForm.zip}
                  onChange={handleAddressChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="country">Country</label>
              <input
                type="text"
                id="country"
                name="country"
                value={addressForm.country}
                onChange={handleAddressChange}
                required
              />
            </div>

            <div className="button-group">
              <button type="submit" className="save-button">Save Address</button>
              <button
                type="button"
                className="cancel-button"
                onClick={() => setIsEditingAddress(false)}
              >
                Cancel
              </button>
            </div>
            </form>
        ) : (
          <div className="address-info">
            <p>{billingInfo.billingAddress.street}</p>
            <p>{billingInfo.billingAddress.city}, {billingInfo.billingAddress.state} {billingInfo.billingAddress.zip}</p>
            <p>{billingInfo.billingAddress.country}</p>
          </div>
        )}
      </div>

      <div className="billing-section">
        <h3>Billing History</h3>
        <div className="invoice-table">
          <div className="invoice-header">
            <div className="invoice-cell">Invoice</div>
            <div className="invoice-cell">Date</div>
            <div className="invoice-cell">Amount</div>
            <div className="invoice-cell">Status</div>
            <div className="invoice-cell">Actions</div>
          </div>

          {billingInfo.invoices.map((invoice, index) => (
            <div key={index} className="invoice-row">
              <div className="invoice-cell">{invoice.id}</div>
              <div className="invoice-cell">{invoice.date}</div>
              <div className="invoice-cell">${invoice.amount.toFixed(2)}</div>
              <div className="invoice-cell">
                <span className={`status-badge ${invoice.status.toLowerCase()}`}>
                  {invoice.status}
                </span>
              </div>
              <div className="invoice-cell">
                <button className="text-button">Download</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default BillingPage;
